import { Button } from 'antd';
import styled, { css } from 'styled-components';

interface CustomOutlineButtonProps {
  margin?: string;
  nomargin?: boolean;
  width?: string;
  height?: string;
  isLowercase?: boolean;
  fullwidth?: boolean;
  disableHover?: boolean;
  hasRightActionIcon?: boolean;
  hasLeftActionIcon?: boolean;
  bordercolor?: string;
  backgroundcolor?: string;
  bghovercolor?: string;
  borderhovercolor?: string;
  colorhover?: string;
  color?: string;
}
export const OutlineButtonColors = {
  primary: {
    fc: 'white',
    bg: '#2665ee',
    bc: '#2665ee',
    bcd: '#56607f',
    transparent: 'rgba(255, 255, 255, 0.5);'
  },
  danger: {
    main: '#e7292d'
  },
  active: {
    main: '#7ebe8b'
  },
  deactivate: {
    main: '#56607f'
  }
};

export const StyledButton = styled(Button)<CustomOutlineButtonProps>`
  &&& {
    margin: ${({ margin, nomargin }) => (nomargin ? '0' : margin ? margin : '0 4px')};
    color: ${({ color }) => color || 'white'};
    border: ${({ type, bordercolor }) =>
      type === 'link' ? 'none' : `1px solid ${bordercolor || OutlineButtonColors.primary.bc}`};
    background: ${({ backgroundcolor }) => backgroundcolor || OutlineButtonColors.primary.bg};
    width: ${({ width }) => width || ''};
    font-size: 14px;
    padding: 0em 0.8em;
    min-width: 79px;
    ${({ type }) =>
      type === 'link' &&
      css`
        box-shadow: none;
      `};
    font-weight: normal;
    ${({ height }) =>
      !height
        ? css`
            height: 44px;
          `
        : css`
            height: ${height}px;
          `};
    ${({ fullwidth }) =>
      fullwidth &&
      css`
        width: 100%;
      `}

    &:hover,
    &:active {
      background-color: ${({ type, bghovercolor }) =>
        bghovercolor ? bghovercolor : type === 'primary' ? '#2665ee' : 'rgba(251, 121, 1, 0.16)'};
      color: ${({ type, colorhover }) =>
        colorhover ? colorhover : type === 'primary' ? 'white' : '#2665ee'};
      border-color: ${({ type, borderhovercolor }) =>
        borderhovercolor
          ? borderhovercolor
          : type === 'primary'
          ? '#2665ee'
          : 'rgba(251, 121, 1, 0.16)'};
    }

    &:disabled,
    [disabled] {
      opacity: 0.65;
    }
    /* &:first-child {
      margin-left: 0;
    } */
    &:last-child {
      margin-right: 0;
    }

    ${({ disableHover }) =>
      disableHover &&
      css`
        &:hover {
          cursor: default;
          background-color: ${
            /* @ts-ignore */
            ({ type }) => (type === 'primary' ? '#2665ee' : type === 'default' ? 'white' : '')
          };
          color: ${
            /* @ts-ignore */
            ({ type }) => (type === 'primary' ? 'white' : type === 'default' ? '#FB7901' : '')
          };
        }
      `}

    ${({ hasRightActionIcon }) =>
      hasRightActionIcon &&
      css`
        .anticon {
          cursor: pointer;
          margin-left: 10px;

          &:hover {
            opacity: 0.7;
          }
        }
      `}
    ${({ hasLeftActionIcon }) =>
      hasLeftActionIcon &&
      css`
        .anticon {
          cursor: pointer;
          margin-right: 10px;

          &:hover {
            opacity: 0.7;
          }
        }
      `}
  }
`;

export default StyledButton;
